import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { FcpivotComponent } from "./fcpivot.component";

const routes: Routes = [
  {
    path: "",
    component: FcpivotComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class FcpivotRoutingModule {}
